/** @format */

const template = `
<span class="tiny-badge accent" ng-if="ctrl.module.documentState == 'DRAFT'">{{ctrl.module|approvalStateName}}</span>
<span class="tiny-badge secondary" ng-if="ctrl.module.documentState == 'DELETED'"
  >{{'VISIBLE_DOCUMENT_STATE.'+ctrl.module.documentState|translate}}</span
>
<span class="tiny-badge success" ng-if="ctrl.module.documentState == 'ACTIVE'"
  >{{'VISIBLE_DOCUMENT_STATE.'+ctrl.module.documentState|translate}}</span
>
`;
export default template;
